<template>
  <div
    class="customer-address--wrap"
    :style="containerStyles"
    v-tooltip="getTooltipHtml(value)"
    v-clipboard:copy="value"
    v-clipboard:success="
      (e) => {
        onCopy(e)
        $emit('copySuccess', e)
      }
    "
    v-clipboard:error="onError"
  >
    <transition name="fade-fast" mode="out-in">
      <div class="truncate" v-if="copied" key="copied">
        <v-icon small color="green" class="mt-n1">mdi-check</v-icon>
        Copied!</div
      >
      <div class="truncate" v-else key="reggy">{{ value }}</div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'AdminCellTextCopiable',
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    width: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      isHovering: false,
      copied: false,
    }
  },
  computed: {
    containerStyles() {
      let maxWidth =
        typeof this.width === 'number' ? `${this.width}px` : this.width
      return {
        maxWidth,
        cursor: 'pointer',
      }
    }, // containerStyles
  }, // computed
  methods: {
    onCopy() {
      this.copied = true
      setTimeout(() => {
        this.copied = false
        this.isHovering = false
      }, 2000)
    },
    onError: function() {
      alert('Failed to copy the text to the clipboard')
    },
    getTooltipHtml() {
      return {
        content: this.copied
          ? '<div class="proxima--font">Copied!</div>'
          : `<div class="proxima--font">${this.value}</div><div class="proxima--font font-italic">(Click to copy)</div>`,
        html: true,
        triggers: ['hover', 'click'],
      }
    }, // getTooltipHtml
  },
}
</script>

<style lang="scss">
.customer-address--wrap {
  .truncate {
    height: auto;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
